import { gql } from '@apollo/client/core';
import ConfigurationFragment from '@/apollo/fragments/Portfolio/PortfolioConfiguration.fragment';
import TestimonialFragment from '@/apollo/fragments/Testimonial.fragment';
import EducationHistoryFragment from '@/apollo/fragments/Portfolio/PortfolioEducationHistory.fragment';

export const PublicPortfolioCurrentUserQuery = gql`
  ${TestimonialFragment}
  ${ConfigurationFragment}
  ${EducationHistoryFragment}

  query PublicPortfolioCurrentUser {
    publicPortfolioCurrentUser {
      testimonials {
        ...TestimonialFragment
      }
      configuration {
        ...ConfigurationFragment
      }
      educationHistories {
        ...EducationHistoryFragment
      }
    }
  }
`;
